<app-step-header [title]="title()"
  [description]="description()"
  [state]="state()"
></app-step-header>
<div id="gbg-container" class="gbg-container">
  @if (nextEnabled()) {
    <div class="success-message-container">
      <div class="success-message">
        <img class="success-icon" src="assets/icons/common/gbg-completed.svg" alt=""/>
        <p class="success-text" role="alert">ID verification step completed.</p>
      </div>
    </div>
  }
  @if (hasError()) {
    <p class="error-text" role="alert">Error loading step. {{supportMessage()}}</p>
  }
</div>
<app-step-footer [state]="state()"
  [nextEnabled]="nextEnabled()"
  (previousClicked)="previous()"
  (nextClicked)="next()"
></app-step-footer>
